import { render, staticRenderFns } from "./FieldSingle.vue?vue&type=template&id=20a2837f&"
import script from "./FieldSingle.vue?vue&type=script&lang=js&"
export * from "./FieldSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports